import { render, staticRenderFns } from "./videoiframe.vue?vue&type=template&id=4d0fc2ee&"
import script from "./videoiframe.vue?vue&type=script&lang=js&"
export * from "./videoiframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0fc2ee')) {
      api.createRecord('4d0fc2ee', component.options)
    } else {
      api.reload('4d0fc2ee', component.options)
    }
    module.hot.accept("./videoiframe.vue?vue&type=template&id=4d0fc2ee&", function () {
      api.rerender('4d0fc2ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MaUjJODNQiOc/JS/videoiframe.vue"
export default component.exports